import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { omit } from 'lodash';
import { ServerDataSource } from 'angular2-smart-table';
import { environment } from '../../../environments/environment';
import { HttpService } from './common/http.service';
import { SalaryStructure, SalaryStructureData } from '../interfaces/salary-structure';
import { defaultDataOmitFields, prepRecordForApi } from '../utils/utils.service';

@Injectable()
export class SalaryStructureService extends SalaryStructureData {

  private readonly url = 'salary-structures';

  get gridDataSource(): ServerDataSource {
    return this.api.getServerDataSource(
      `${environment.API_BASE_URL}/${this.url}?sort=name:asc`
    );
  }

  constructor(private api: HttpService) {
    super();
  }

  listAll(config?: any): Observable<SalaryStructure[]> {
    let url = `${this.url}?pagination[pageSize]=500&sort=name:asc`;
    if (config) {
      Object.keys(config).forEach(key => {
        const queryKey = key.startsWith('filters[') ? key : `filters[${key}][$eq]`;
        url += `&${queryKey}=${config[key]}`;
      });
    }
    return this.api.get(url).pipe(
      map((res) => res.data ?? res)
    );
  }

  list(pageNumber: number, pageSize: number): Observable<SalaryStructure[]> {
    let url = `${this.url}?sort=name:asc`;
    if (pageSize > 0)   url += `&pagination[pageSize]=${pageSize}`;
    if (pageNumber > 0) url += `&pagination[page]=${pageNumber}`;
    return this.api.get(url).pipe(map((res) => res.data ?? res));
  }

  get(id: string): Observable<SalaryStructure> {
    return this.api.get(`${this.url}/${id}`).pipe(map((res) => res.data ?? res));
  }

  create(record: Partial<SalaryStructure>): Observable<SalaryStructure> {
    const data = prepRecordForApi(omit(record, [...defaultDataOmitFields]));
    return this.api.post(this.url, { data }).pipe(map((res) => res.data ?? res));
  }

  update(record: SalaryStructure): Observable<SalaryStructure> {
    const data = prepRecordForApi(omit(record, [...defaultDataOmitFields, 'id', 'documentId', 'createdAt', 'updatedAt']));
    return this.api.put(`${this.url}/${record.documentId}`, { data }).pipe(map((res) => res.data ?? res));
  }

  delete(id: string): Observable<boolean> {
    return this.api.delete(`${this.url}/${id}`).pipe(map(() => true));
  }
}
